import { ArrowRight, ArrowUpRight } from "lucide-react";

const services = [
  {
    n: "01",
    title: "Coaching",
    desc: "1:1 executive and growth coaching for professionals stepping into leadership, navigating transitions, and building real, repeatable confidence.",
    cta: "Book a discovery call",
    href: "#booking",
    type: "scroll",
  },
  {
    n: "02",
    title: "Speaking",
    desc: "Panels, keynotes, workshops, and leadership conversations on creative leadership, brand building, and growth.",
    cta: "Connect for a speaking gig",
    href: "mailto:binaiferdulani@gmail.com",
    type: "mail",
  },
];

export default function Services() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 md:py-36 bg-[#FAFAF8] border-t border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="reveal max-w-3xl mb-16 md:mb-20">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#6B6B6B] mb-5 font-medium">
            05. Work With Me
          </div>
          <h2 className="font-display text-[#0A0A0A] text-[34px] sm:text-[44px] lg:text-[56px] font-medium leading-[1.08] tracking-[-0.025em]">
            Get in touch
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl">
          {services.map((s, i) => (
            <article
              key={s.title}
              data-testid={`service-card-${i}`}
              className="reveal bg-white border border-black/10 rounded-sm p-10 md:p-12 flex flex-col h-full transition-all duration-500 hover:border-[#0A0A0A]"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex items-baseline justify-between">
                <span className="font-display text-[12px] text-[#6B6B6B] tracking-[0.04em] font-medium">
                  {s.n}
                </span>
              </div>
              <h3 className="mt-10 font-display text-[32px] md:text-[40px] text-[#0A0A0A] font-medium tracking-[-0.025em] leading-[1.05]">
                {s.title}
              </h3>
              <p className="mt-6 text-[16px] md:text-[17px] text-[#3A3A3A] leading-[1.65] flex-1">
                {s.desc}
              </p>
              {s.type === "scroll" ? (
                <button
                  data-testid={`service-cta-${i}`}
                  onClick={() => scrollTo(s.href)}
                  className="group mt-12 inline-flex items-center gap-2 text-[13px] font-medium text-[#0A0A0A] hover:opacity-60 transition-opacity self-start"
                >
                  {s.cta}
                  <ArrowRight
                    size={14}
                    className="transition-transform duration-300 group-hover:translate-x-1"
                  />
                </button>
              ) : (
                <a
                  href={s.href}
                  data-testid={`service-cta-${i}`}
                  className="group mt-12 inline-flex items-center gap-2 text-[13px] font-medium text-[#0A0A0A] hover:opacity-60 transition-opacity self-start"
                >
                  {s.cta}
                  <ArrowUpRight
                    size={14}
                    className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </a>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
